import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { HttpService } from "../../components/services/HttpService";
import { PatientTypeConstants } from "../types/PatientTypeConstants";
import { PatientActions } from "../actions/PatientActions";
import { BackDropActions } from "../actions/BackDropActions";
import { AlertActions } from "../actions/AlertActions";

function* register(action) {
  var user = action.data;
  try {
    var payload = {
      "userName": user.email,
      "firstName": user.firstName,
      "lastName": user.lastName,
      "password": user.password,
      "email": user.email,
      "dateOfBirth": user.dob?user.dob:'',
      "telePhoneNo": user.phoneNo,
      "status": user.status,
      "emailOptOut": user.emailOptOut,
      "emailOptIn": user.emailOptIn,
      "mailAddress": user.mailAddress,
      "mailingOptIn": user.mailingOptIn,
      "mailingOptOut": user.mailingOptOut,
      "phoneNoOptIn": user.phoneNoOptIn,
      "phoneNoOptOut": user.phoneNoOptOut,
      "mobilePhoneNo": user.mobilePhoneNo,
      "mobOptIn": user.mobOptIn,
      "mobOptOut": user.mobOptOut,
      "elcNotiOptIn": user.elcNotiOptIn,
      "elcNotiOptOut": user.elcNotiOptOut,
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/patient/register", payload);
    if(response.status==="SUCCESS"){
      yield put(PatientActions.registrationSuccess(response.result));
    }else{
      yield put(PatientActions.registrationFailiure(response.result));
    }
  } catch (e) {
    yield put(PatientActions.registrationFailiure(e));
  }
}

function* registrationSuccess(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.success("Registered successfully."));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* registrationFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message.description));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* updateProfile(action) {
  try {
    var user = action.data;
    var payload = {
      'id':user.id,
      "firstName": user.firstName,
      "lastName": user.lastName,
      "email": user.email,
      "dateOfBirth": user.dob,
      "telePhoneNo": user.phoneNo,
      "status": user.status,
      "emailOptOut": user.emailOptOut,
      "emailOptIn": user.emailOptIn,
      "mailAddress": user.mailAddress,
      "mailingOptIn": user.mailingOptIn,
      "mailingOptOut": user.mailingOptOut,
      "phoneNoOptIn": user.phoneNoOptIn,
      "phoneNoOptOut": user.phoneNoOptOut,
      "mobilePhoneNo": user.mobilePhoneNo,
      "mobOptIn": user.mobOptIn,
      "mobOptOut": user.mobOptOut,
      "elcNotiOptIn": user.elcNotiOptIn,
      "elcNotiOptOut": user.elcNotiOptOut,
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.put, "/patient/update", payload);
    if(response.status==="SUCCESS"){
      yield put(PatientActions.updateProfileSuccess(response.result));
    }else{
      yield put(PatientActions.updateProfileFailiure(response.result));
    }
} catch (e) {
    yield put(PatientActions.updateProfileFailiure(e));
  }
}
function* updateProfileSuccess(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.success("Updated successfully."));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* updateProfileFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message.description));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* updateAddressInfo(action) {
  try {
    var user = action.user;
    var payload = {
      "id": user.id,
      "phyAddress1": user.phyAddress1,
      "phyAddress2": user.phyAddress2,
      "phyAddress3": user.phyAddress3,
      "phyCity": user.phyCity,
      "phyState": user.phyState,
      "phyZipCode": user.phyZipCode,
      "billingAddress1": user.billingAddress1,
      "billingAddress2": user.billingAddress2,
      "billingAddress3": user.billingAddress3,
      "billingCity": user.billingCity,
      "billingState": user.billingState,
      "billingZipCode": user.billingZipCode,
      "isBillingAddressSameAsPhysicalAddress": user.isBillingAddressSameAsPhysicalAddress
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.put, "/patient/update/address", payload);
    if(response.status==="SUCCESS"){
      yield put(PatientActions.updateProfileSuccess(response.result));
    }else{
      yield put(PatientActions.updateProfileFailiure(response.result));
    }
} catch (e) {
    yield put(PatientActions.updateProfileFailiure(e));
  }
}

function* updateInsuranceInfo(action) {
  try {
    var user = action.user;
    var payload = {
      "id": user.id,
      "primaryHealthInsurer": user.primaryInsurer,
      "primaryHealthInsurerId": user.primaryInsurerId,
      "secondaryHealthInsurer": user.secondaryInsurer,
      "secondaryHealthInsurerId": user.secondaryInsurerId,
      "emgrContName": user.emrContactName,
      "emgrContPhone": user.emrContactNo,
      "emgrContRelation": user.emrRelationShip
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.put, "/patient/update/insuranceinfo", payload);
    if(response.status==="SUCCESS"){
      yield put(PatientActions.updateProfileSuccess(response.result));
    }else{
      yield put(PatientActions.updateProfileFailiure(response.result));
    }
} catch (e) {
    yield put(PatientActions.updateProfileFailiure(e));
  }
}


function* getAllPatients(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get, "/patient");
    if(response.status==="SUCCESS"){
      yield put(PatientActions.getAllPatientSuccess(response.result));
    }else{
      yield put(PatientActions.getAllPatientFailiure(response.result));
    }
  } catch (e) {
    yield put(PatientActions.getAllPatientFailiure(e));
  }
}

function* getActiveAllPatients(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get, "/patient/all");
    if(response.status==="SUCCESS"){
      yield put(PatientActions.getAllPatientSuccess(response.result));
    }else{
      yield put(PatientActions.getAllPatientFailiure(response.result));
    }
  } catch (e) {
    yield put(PatientActions.getAllPatientFailiure(e));
  }
}

function* getAllPatientSuccess(action) {
  try {
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* getAllPatientFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message.description));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* getPatientById(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get, "/patient/" + action.id);
    if(response.status==="SUCCESS"){
      yield put(PatientActions.getPatientByIdSuccess(response.result));
    }else{
      yield put(PatientActions.getPatientByIdFailiure(response.result));
    }
  } catch (e) {
    yield put(PatientActions.getPatientByIdFailiure(e));
  }
}

function* getPatientByUserId(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get, "/patient/byuserid/" + action.id);
    if(response.status==="SUCCESS"){
      yield put(PatientActions.getPatientByIdSuccess(response.result));
    }else{
      yield put(PatientActions.getPatientByIdFailiure(response.result));
    }
  } catch (e) {
    yield put(PatientActions.getPatientByIdFailiure(e));
  }
}


function* getPatientByIdSuccess(action) {
  try {
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* getPatientByIdFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message.description));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* searchPatient(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/patient/search",action.data);
    if(response.status==="SUCCESS"){
      yield put(PatientActions.searchPatientSuccess(response.result));
    }else{
      yield put(PatientActions.searchPatientFailiure(response.message.description));
    }
  } catch (e) {
    yield put(PatientActions.searchPatientFailiure(e));
  }
}

function* searchPatientSuccess(action) {
  try {
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* searchPatientFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message.description));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}


function* searchPatientAppointment(action) {
  try {
    console.log("searchPatientAppointment =>" + JSON.stringify(action));
    yield put(BackDropActions.start());
    const data = yield call(HttpService.get, "/appointments");
    yield put(PatientActions.getPatientByIdSuccess(data));
  } catch (e) {
    yield put(PatientActions.getPatientByIdFailiure(e));
  }
}

function* searchPatientAppointmentSuccess(action) {
  try {
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* searchPatientAppointmentFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message.description));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* sendSMS(action) {
  try {
    var payload = action.data;
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/patient/send/sms", payload);
    if (response && response.status && "SUCCESS" === response.status) {
      yield put(
        AlertActions.success("Send message successfully.")
      );
    } else {
      yield put(AlertActions.error(response.result.description));
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
    yield put(BackDropActions.end());
  }
}



function* patientSaga() {
  yield takeEvery(PatientTypeConstants.REGISTER_PATIENT_REQUEST, register);
  yield takeEvery(PatientTypeConstants.REGISTER_PATIENT_FAILURE, registrationFailiure);
  yield takeEvery(PatientTypeConstants.REGISTER_PATIENT_SUCCESS, registrationSuccess);
  
  yield takeEvery(PatientTypeConstants.UPDATE_PATIENT_REQUEST, updateProfile);
  yield takeEvery(PatientTypeConstants.UPDATE_PATIENT_SUCCESS, updateProfileSuccess);
  yield takeEvery(PatientTypeConstants.UPDATE_PATIENT_FAILURE, updateProfileFailiure);
  
  yield takeEvery(PatientTypeConstants.UPDATE_PATIENT_REQUEST, updateProfile);
  yield takeEvery(PatientTypeConstants.UPDATE_PATIENT_SUCCESS, updateProfileSuccess);
  yield takeEvery(PatientTypeConstants.UPDATE_PATIENT_FAILURE, updateProfileFailiure);
  
  yield takeEvery(PatientTypeConstants.UPDATE_PATIENT_REQUEST, updateProfile);
  yield takeEvery(PatientTypeConstants.UPDATE_PATIENT_SUCCESS, updateProfileSuccess);
  yield takeEvery(PatientTypeConstants.UPDATE_PATIENT_FAILURE, updateProfileFailiure);

  yield takeEvery(PatientTypeConstants.GET_ALL_PATIENT_REQUEST, getAllPatients);
  yield takeEvery(PatientTypeConstants.GET_ALL_ACTIVE_PATIENT_REQUEST, getActiveAllPatients);
  
  yield takeEvery(PatientTypeConstants.GET_ALL_PATIENT_SUCCESS, getAllPatientSuccess);
  yield takeEvery(PatientTypeConstants.GET_ALL_PATIENT_FAILIURE, getAllPatientFailiure);
  yield takeEvery(PatientTypeConstants.GET_PATIENT_BY_ID_REQUEST, getPatientById);
  yield takeEvery(PatientTypeConstants.GET_PATIENT_BY_ID_SUCCESS, getPatientByIdSuccess);
  yield takeEvery(PatientTypeConstants.GET_PATIENT_BY_ID_FAILIURE, getPatientByIdFailiure);
  yield takeEvery(PatientTypeConstants.SEARCH_PATIENT_REQUEST, searchPatient);
  yield takeEvery(PatientTypeConstants.SEARCH_PATIENT_SUCCESS, searchPatientSuccess);
  yield takeEvery(PatientTypeConstants.SEARCH_PATIENT_FAILIURE, searchPatientFailiure);
  yield takeEvery(PatientTypeConstants.SEARCH_PATIENT_FAILIURE, searchPatientAppointment);
  yield takeEvery(PatientTypeConstants.PATIENT_APPOINTMENT_REQUEST, searchPatient);
  yield takeEvery(PatientTypeConstants.PATIENT_APPOINTMENT_SUCCESS, searchPatientAppointmentSuccess);
  yield takeEvery(PatientTypeConstants.PATIENT_APPOINTMENT_FAILIURE, searchPatientAppointmentFailiure);

  yield takeEvery(PatientTypeConstants.UPDATE_PATIENT_ADDRESS_REQUEST, updateAddressInfo);
  yield takeEvery(PatientTypeConstants.UPDATE_PATIENT_INS_INFO_REQUEST, updateInsuranceInfo);

  yield takeEvery(PatientTypeConstants.SEND_SMS_TO_PATIENT, sendSMS);
  
  
}

export default patientSaga;
